/**
 * Mobile Menu functionality
 *
 * @description This file includes the required functionality for the mobile menu
 *
 * @return void
 * @access public
 *
 */

import {body, header, addEventListenerIfElExists, findAncestor, viewportWidth} from './helpers';


export const mobileMenu = () => {
	const openMenu              = document.querySelector( '.js-toggle-menu' );
	const closeMenu             = document.querySelector( '.js-close-menu' );
	const mobileMenuWrapper     = document.querySelector( '.js-mobile-menu' );
	const menuItemsWithChildren = document.querySelectorAll( '.menu__item.has-children > .menu__link' );

	/**
	 * Implement toggle functionality
	 * for the mobile toggle element
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 *
	 */
	function openMenuTrigger( el, id ) {
		el.preventDefault();

		const animatedClass     = 'animated';
		const animationIn       = mobileMenuWrapper.getAttribute( 'data-anim-in' );
		const animationOut      = mobileMenuWrapper.getAttribute( 'data-anim-out' );
		const animationDuration = mobileMenuWrapper.getAttribute( 'data-anim-duration' );
		const menuClosedClass   = 'is-menu-closed';
		let isMobileMenuClosed  = mobileMenuWrapper.classList.contains( menuClosedClass );

		mobileMenuWrapper.style['-webkit-animation-duration'] = animationDuration + 'ms'; // Set the animation duration based on the data attribute
		mobileMenuWrapper.classList.add( animatedClass ); // Add the `animated` class so any animation can start
		setTimeout( () => {
			mobileMenuWrapper.classList.remove( animatedClass ); // And remove the `animated` class once the animation is over, so we can use it in both in and out
		}, animationDuration );


		// Check if mobile menu is closed
		if ( isMobileMenuClosed ) {
			header.classList.add( 'menu-toggled' ); // Add the `menu-toggled` class to the header
			// body.classList.add('is-hidden'); // Add the `is-hidden` class to make body overflow hidden (In favor of Issue #12)
			mobileMenuWrapper.classList.add( animationIn );
			setTimeout( () => {
				mobileMenuWrapper.classList.remove( menuClosedClass ); // Remove the `is-menu-closed` class from the mobile menu
				mobileMenuWrapper.classList.remove( animationIn ); // Remove the animation in class
			}, animationDuration );
		} else { // Else if mobile menu is open
			mobileMenuWrapper.classList.add( animationOut ); // Add the out animation class
			// body.classList.remove('is-hidden'); // Remove the `is-hidden` class to prevent body from being overflow hidden (In favor of Issue #12)
			// Run a setTimeout which is the same duration as the animationDuration
			setTimeout( () => {
				header.classList.remove( 'menu-toggled' ); // Remove the `menu-toggled` class from the header
				mobileMenuWrapper.classList.add( menuClosedClass ); // Add the `is-menu-closed` class to the mobile menu
				mobileMenuWrapper.classList.remove( animationOut ); // Remove the animation out class
			}, animationDuration );
		}
	}

	/**
	 * Implement close functionality
	 * for the mobile toggle element
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 *
	 */
	function closeMenuTrigger( element, id ) {
		const animatedClass     = 'animated';
		const animationIn       = mobileMenuWrapper.getAttribute( 'data-anim-in' );
		const animationOut      = mobileMenuWrapper.getAttribute( 'data-anim-out' );
		const animationDuration = mobileMenuWrapper.getAttribute( 'data-anim-duration' );
		const menuClosedClass   = 'is-menu-closed';
		let isMobileMenuClosed  = mobileMenuWrapper.classList.contains( menuClosedClass );

		mobileMenuWrapper.style['-webkit-animation-duration'] = animationDuration + 'ms'; // Set the animation duration based on the data attribute
		mobileMenuWrapper.classList.add( animatedClass ); // Add the `animated` class so any animation can start
		setTimeout( () => {
			mobileMenuWrapper.classList.remove( animatedClass ); // And remove the `animated` class once the animation is over, so we can use it in both in and out
		}, animationDuration );


		mobileMenuWrapper.classList.add( animationOut ); // Add the out animation class
		body.classList.remove( 'is-hidden' ); // Remove the `is-hidden` class to prevent body from being overflow hidden
		// Run a setTimeout which is the same duration as the animationDuration
		setTimeout( () => {
			header.classList.remove( 'menu-toggled' ); // Remove the `menu-toggled` class from the header
			mobileMenuWrapper.classList.add( menuClosedClass ); // Add the `is-menu-closed` class to the mobile menu
			mobileMenuWrapper.classList.remove( animationOut ); // Remove the animation out class
		}, animationDuration );
	}

	/**
	 * Implement toggle functionality for mobile menu items
	 * that have submenu items inside them
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 */
	if ( viewportWidth < 1260 ) {

		menuItemsWithChildren.forEach( ( item, index ) => {
			item.addEventListener( 'click', event => {
				event.preventDefault();

				findAncestor( event.target, '.menu__item' ).classList.toggle( 'menu__item--open' );

			} );
		} );


	}


	// Event Listeners
	addEventListenerIfElExists( openMenu, openMenuTrigger );
	addEventListenerIfElExists( closeMenu, closeMenuTrigger );

}
